import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { useEditEmployerOpportunitiesForm } from './useEditEmployerOpportunitiesForm';
import { convertToRaw } from 'draft-js';
import CommonRichEditor from '../../Common/CommonComponents/CommonRichEditor';
import NewCommonRichEditor from '../../Common/CommonComponents/NewCommonRichEditor';

export type EditEmployerOpportunitiesFormProps = {
    isAdmin: boolean,
}

export const EditEmployerOpportunitiesForm: React.FC<EditEmployerOpportunitiesFormProps> = ({ isAdmin = false }) => {
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = useEditEmployerOpportunitiesForm(true);
    const history = useHistory();

    if (!isAdmin) {
        return <div className='EO-public pain-html'>
            {/* <h2>RSA Employment Opportunity</h2> */}
            <div dangerouslySetInnerHTML={{__html:values.rsaemploymentOpportunity}}></div>
            {/* <h2>Recruiting Hiring Event</h2>
            <div dangerouslySetInnerHTML={{__html:values.recruitingHiringEvent}}></div>
            <h2>Disability Awareness Month Event</h2>
            <div dangerouslySetInnerHTML={{__html:values.disabilityAwarenessMonthEvent}}></div> */}
            
        </div>
    }

    return <div>
        <Form loading={isSubmitting}>
            <Form.Field>
                <label className='EO-section-title'>Page content</label>
                <NewCommonRichEditor
                    value = {values.rsaemploymentOpportunity}
                    onChange = {(newValue:string)=>{
                        //console.log('content changed', newValue);
                        handleChange(newValue, 'rsaemploymentOpportunity');
                    }}
                    onBlur = {()=>{
                        handleBlur('rsaemploymentOpportunity');
                    }}
                />
            </Form.Field>
            {
                !(!errors.rsaemploymentOpportunity || !touched.rsaemploymentOpportunity) &&
                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.rsaemploymentOpportunity}</div>
            }
            
            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
            
            <Button type='button' onClick={() => { 
                if(isAdmin){
                    history.push('/dashboard');
                }
                else {
                    history.push('/');
                }
            }}>Cancel</Button>
        </Form>
    </div>
}